import Link from "next/link";

export default function SiteQuickLinks({ locale = "en", className = "" }) {
	const copy =
		locale === "es"
			? {
					heading: "Explore Technical Union",
					links: [
						{ href: "/es/productos", label: "Catálogos de productos" },
						{ href: "/es/inventario", label: "Inventario y referencias" },
						{ href: "/es/video-blog", label: "Video blogs" },
						{ href: "/es/formulas-hidraulicas", label: "Calculadora hidráulica" },
						{ href: "/es/contactenos", label: "Contacto y cotizaciones" },
					],
				}
			: {
					heading: "Explore Technical Union",
					links: [
						{ href: "/en/products", label: "Product catalogs" },
						{ href: "/en/inventory", label: "Inventory & cross-references" },
						{ href: "/en/video-blogs", label: "Video blogs" },
						{ href: "/en/fluid-power-formulas", label: "Fluid power calculator" },
						{ href: "/en/contact-us", label: "Contact & quotes" },
					],
				};

	return (
		<nav
			className={`tu-quick-links ${className}`.trim()}
			aria-label={copy.heading}
		>
			<h2 className="tu-quick-links__heading">{copy.heading}</h2>
			<ul className="tu-quick-links__list">
				{copy.links.map((link) => (
					<li key={link.href}>
						<Link
							href={link.href}
							className="tu-quick-links__link"
							prefetch={false}
						>
							{link.label}
						</Link>
					</li>
				))}
			</ul>
		</nav>
	);
}
